module.exports = __webpack_public_path__ + "img/urAnswer.9b956cdf.svg";